import { DatadogLoggerService } from './DatadogLogger';
import { ParallelLoggerService } from './ParallelLogger';
import type { ILogger } from '@types';

// Datadog is the only log transport. ParallelLoggerService stays as the
// wrapper because it owns toast painting and isolates transport failures.
export const logger: ILogger = new ParallelLoggerService([
  new DatadogLoggerService(),
]);
